import { Component, OnInit, ViewChild, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subject, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, catchError, map } from 'rxjs/operators';

import { OverlayEventDetail } from '@ionic/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { Browser } from '@capacitor/browser';

import SignaturePad from 'signature_pad';

import { AjaxService } from '../ajax.service';
import { GlobalService } from '../global.service';
import { UploadService } from '../upload.service';
import { RecordFormPage } from '../record-form/record-form.page';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';

// nog opnemen: foto-viewer: https://www.npmjs.com/package/ng-image-fullscreen-view

@Component({
    selector: 'app-orders',
    templateUrl: './orders.page.html',
    styleUrls: ['./orders.page.scss'],
    standalone: false
})

export class OrdersPage implements OnInit {
    inpProjnr = ''; // invoerveld project
    searchTab = 0;
    afgesloten = false;
    inpProjSubject: Subject<string> = new Subject();
    projlist: any[] = []; // keuze-mogelijkheden project
    ordernr = ''; // geselecteerde project
    projData: any = {}; // alle gegevens van geselecteerd project
    fields: any[] = [];
    uren: any[] = [];
    artikelen: any[] = [];
    ingekocht: any[] = [];
    werkbon: any = {};
    aantekeningen: any[] = [];
    initialisatie = true;

    ordersPlan: any[] = [];
    ordersRecent: any[] = [];

    viewerOpen = false;
    scanCamera = false;
    currSub = '';
    imgs   = [];
    docs   = [];
    dirs   = [];
    currFile = {};
    files  = [];
    idx = 1;
    loadingImgs = false;
    editInstr = false;
    ordInstr = {value: ''};

    prevBonnen = [];
    newBon = false;
    magGereedmelden = true;
    lisappFeatures = true;
    gridCols = 3;
    gridTredes = 3;
    gridSelectCols = 3;
    gridHeight = 300;

    formulierFeature = false;
    formType = '';
    forms = [];
    formsAangemaakt = [];

    ordrLineEdit = false;
    ordrArtnr = '';
    ordrArtChoices = [];
    ordrQty = 1;
    ordrOms = '';
    ordrArtShow = {};
    ordrArtShowImg = '';
    ordrLineID = '';

    opdracht = {
        betaalwijze: 'PIN',
        aanbetaling: 0
    };
    opdracht0 = this.opdracht;
    subtotalExcl = 0;
    subtotalIncl = 0;
    subtotalExclDispl = '';
    subtotalInclDispl = '';

    kortingExclDispl = '';
    kortingInclDispl = '';

    totalExcl = 0;
    totalIncl = 0;
    totalExclDispl = '';
    totalInclDispl = '';

    handtekGezet = false;

    @ViewChild('fileUpload', {static: false}) fileUpload: ElementRef;
    @ViewChild('inpProjnrRef', {static: false}) inpProjNrRef: ElementRef;
    @ViewChild(MatMenuTrigger) filemenuTrigger: MatMenuTrigger;

    signaturePad: SignaturePad;
    @ViewChild('signpad', {static: false}) signaturePadElt: ElementRef;
    @ViewChildren('signpad') signpads: QueryList<SignaturePad>;
    signOpdrPad: SignaturePad;
    @ViewChild('signOpdr', {static: false}) signOpdrElt: ElementRef;
    @ViewChildren('signOpdr') signOpdrs: QueryList<SignaturePad>;

    /*
    signaturePadOptions: object = { // passed through to szimek/signature_pad constructor
        minWidth: 0.5,
        canvasWidth: 300,
        canvasHeight: 150,
        backgroundColor: 'rgb(234, 243, 249)',
    };
    */

    constructor(
        public router: Router,
        public alertController: AlertController,
        public modalController: ModalController,
        public global: GlobalService,
        public platform: Platform,
        private ajax: AjaxService,
        private uploadService: UploadService,
        private snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            this.router.navigateByUrl('login');
        }
        this.projData.OrderActief = false;

        this.inpProjSubject.pipe(
            debounceTime(500),
            distinctUntilChanged()
        ).subscribe(
            value => {
                this.onChangeProj(value);
            }
        );

        this.setWerkbonEmpty();
    }

    ionViewWillEnter() {
        const projnr: string = localStorage.getItem('lastProjNr');
        this.lisappFeatures = (this.global.getvar('app-voorraad-lisapp') === '1');
        this.inpProjnr = projnr;
        this.onChangeProj(projnr);
        this.onResize();
        this.formulierFeature = (this.global.getmod('for') > 0);
        this.initialisatie = false;
    }

    ionViewDidEnter() {
        this.signpads.changes.subscribe(() => {
            if (this.signaturePadElt) {
                if (!this.signaturePad) {
                    this.signaturePad = new SignaturePad(this.signaturePadElt.nativeElement);
                    console.log('signaturepad Werkbon initialized.');
                }
            }
        });
        this.signOpdrs.changes.subscribe(() => {
            if (this.signOpdrElt) {
                if (!this.signOpdrPad) {
                    this.signOpdrPad = new SignaturePad(this.signOpdrElt.nativeElement);
                    console.log('signaturepad Opdracht initialized.');
                }
            }
        });
    }

    setWerkbonEmpty() {
        this.werkbon.gereed = this.global.getvar('appWerkbonGereed', '0');
        this.werkbon.lines = [];
        this.werkbon.previous = [];
        this.werkbon.omschr = '';
        this.werkbon.naam = '';
        this.werkbon.email = '';
        console.log('werkbon empty set');
        this.ajax.get('werkbonNieuw', {ordernr: this.ordernr})
        .then((data: any) => {
            this.werkbon.lines = (data.lines) ? data.lines : [];
            this.prevBonnen = (data.bonnen) ? data.bonnen : [];
            this.werkbon.email = (data.cc) ? data.cc : '';
            console.log('werkbonNieuw sent');
        });
    }

    werkbonSave() {
        this.snackBar.open('Werkbon wordt verzonden ...');
        if (this.signaturePad) {
            this.werkbon.signature = this.signaturePad.toDataURL();
        }
        console.log('werkbonSave start');
        this.ajax.get('werkbonSave', {
            ordernr: this.ordernr,
            werkbon: this.werkbon,
        })
        .then((data: any) => {
            console.log('werkbonSave sent');
            this.snackBar.open('Werkbon is verzonden.', 'OK', {
                duration: 3000
            });
            console.log('werkbonSave snackbar start');
            this.setWerkbonEmpty();
            console.log('werkbon emptied');
        })
        .catch(error => {
            console.log('werkbonSave error', error);
            this.snackBar.open('ERROR bij aanmaken werkbon', 'OK', {duration: 10000});
            this.setWerkbonEmpty();
        });
        this.drawClear();
        this.showProjKaart(this.ordernr);
    }

    opdrachtSave() {
        this.snackBar.open('Opdracht wordt vastgelegd ...');
        console.log('opdrachtSave start');
        this.ajax.get('opdrachtSave', {
            ordernr: this.ordernr,
            korting: this.projData.KlantKorting,
            totaalIncl: this.totalInclDispl,
            totaalExcl: this.totalExclDispl,
            btw: this.global.optInclBtw,
            aanbetaling: this.opdracht.aanbetaling,
            betaalwijze: this.opdracht.betaalwijze,
            signature: this.signOpdrPad.toDataURL()
        })
        .then((data: any) => {
            console.log('opdrachtSave sent');
            this.snackBar.open('Opdracht is vastgelegd.', 'OK', {
                duration: 3000
            });
            this.drawClearOpdr();
            this.showProjKaart(this.ordernr);
        })
        .catch(error => {
            console.log('opdrachtSave error', error);
            this.snackBar.open('ERROR bij vastleggen opdracht', 'OK', {duration: 10000});
        });
    }

    projChanged(event) {
        this.inpProjSubject.next(event);
        if (this.searchTab<1) {
            this.searchTab=1;
        }
    }

    startProjectSearch() {
        // aanvang opbouw view
        this.ajax.get('orderSuggest')
        .then((data: any) => {
            if (!data.login) {
                this.dataError(data);
            } else {
                this.ordersPlan = (data.ordersPlan) ? data.ordersPlan : [];
                this.ordersRecent = (data.ordersRecent) ? data.ordersRecent : [];
            }
        });
        this.ordernr = '';
    }

    async doScanProj() {
        if (!await this.global.startCamera()) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss()
        .then((dataPar: OverlayEventDetail) => {
            this.scanCamera = false;
            if (dataPar.data.code) {
                this.inpProjnr = dataPar.data.code;
                this.showProjKaart(this.inpProjnr);
            }
        });
        return await myDlg.present();
    }

    doClearProj() {
        this.inpProjnr = '';
        this.ordernr = '';
        this.onChangeProj('');
        this.inpProjNrRef.nativeElement.focus();
    }

    onChangeTabProj() {
        this.onChangeProj(this.inpProjnr);
    }

    onChangeProj(nwProjNr) {
        this.startProjectSearch();
        this.ajax.get('projList', {req: nwProjNr, afgesloten: this.searchTab<2})
        .then((data: any) => {
            if (!data.login) {
                this.dataError(data);
            } else {
                this.projlist = data.txt;
                if (this.projlist.length === 1
                    && this.projlist[0].nr.toLowerCase() === nwProjNr.toLowerCase()) {
                    this.click_proj(this.projlist[0].nr);
                } else {
                    data.txt.forEach(element => {
                        if (element.nr && nwProjNr && element.nr.toLowerCase() === nwProjNr.toLowerCase()) {
                            this.showProjKaart(nwProjNr);
                        }
                    });
                }
                if (this.initialisatie && this.projlist.length === 0) {
                    this.doClearProj();
                }
            }
        });
    }

    click_proj(nwProjNr) {
        this.inpProjnr = nwProjNr;
        this.projlist = [];
        this.showProjKaart(nwProjNr);
    }

    showProjKaart(nwProjNr) {
        this.ordernr = nwProjNr;
        localStorage.setItem('lastProjNr', nwProjNr);
        this.ajax.get('orderDetails', {req: nwProjNr})
        .then((data: any) => {
            if (!data.login) {
                this.dataError(data);
            } else {
                console.log('orderDetails:', data);
                this.fields = data.fields;
                this.ordInstr = this.fields.find(e => e.tag === 'Instructie');
                this.projData = data;
                this.prevBonnen = (data.bonnen) ? data.bonnen : [];
                this.werkbon.gereed = (data.OrderType === 'Z') ? '1' : this.global.getvar('appWerkbonGereed', '0');
                this.newBon = false;
                this.magGereedmelden = (this.global.getvar('lisapp-gereedmeld', '1') === '1');
                this.uren = (data.uren) ? data.uren : [];
                this.artikelen = (data.artikelen) ? data.artikelen : [];
                this.ingekocht = (data.ingekocht) ? data.ingekocht : [];
                this.opdracht = (data.opdracht) ? data.opdracht : this.opdracht0;
                this.calcTotal();
                this.aantekeningen = (data.aantekeningen) ? data.aantekeningen : [];
            }
        });
        if (this.formulierFeature) {
            this.ajax.get('formulieren', {
                OrdNr: nwProjNr
            }).then((data: any) => {
                this.forms = data.forms;
                this.formType = this.forms[0].ID;
                this.formsAangemaakt = data.aangemaakt;
            });
        }
        this.currSub = '';
        this.loadImgs();
        this.setWerkbonEmpty();
    }

    fileMenu(i: number, file, event: MouseEvent) {
        event.stopPropagation();
        console.log('filemenu', i, event);
        console.log('clientRect', document.getElementById('main-content').getBoundingClientRect());
        this.idx = i;
        this.currFile = file;
        console.log('idx', this.idx);
        const menuPos = document.getElementById('filemenuID');
        const offset = document.getElementById('main-content').getBoundingClientRect();
        menuPos.style.display = '';
        menuPos.style.position = 'fixed';
        menuPos.style.left = event.clientX + 5 - offset.x + 'px';
        menuPos.style.top = event.clientY + 5 - offset.y + 'px';
        this.filemenuTrigger.openMenu();
    }

    fileDelete() {
        this.alertController.create({
            header: 'Bestand definitief verwijderen?',
            buttons: [
              {
                text: 'Nee',
                handler: () => {
                  console.log('Dan niet');
                }
              },
              {
                text: 'OK',
                handler: () => {
                    console.log('Delete file', this.idx, this.imgs[this.idx]);
                    this.ajax.get('delFile', {
                        table: 'orders', value: this.ordernr, subdir: '/foto' + this.currSub,
                        fname: this.currFile['filename'],
                    }).then((data: any) => {
                        this.loadImgs();
                    });
                }
              }
            ]
          }).then(res => {
            res.present();
          });
    }

    uploadFile(file) {
        const formData = new FormData();
        formData.append('comp', this.global.compname);
        formData.append('usr', this.global.username);
        formData.append('pwd', this.global.password);
        formData.append('ses', this.global.session);
        formData.append('val', this.ordernr);
        formData.append('sub', 'foto' + this.currSub);
        formData.append('file', file.data);
        file.inProgress = true;

        this.uploadService.upload(formData).pipe(
          map(event => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                file.progress = Math.round(event.loaded * 100 / event.total);
                break;
              case HttpEventType.Response:
                return event;
            }
          }),
          catchError((error: HttpErrorResponse) => {
            file.inProgress = false;
            return of(`${file.data.name} upload failed.`);
          })).subscribe((event: any) => {
            if (typeof (event) === 'object') {
                file.inProgress = false;
                let busy = false;
                for (const afile of this.files) {
                    busy = busy || afile.inProgress;
                }
                if (!busy) {
                    this.files = [];
                    this.loadImgs();
                }
            }
          });
      }

    private uploadFiles() {
        this.fileUpload.nativeElement.value = '';
        this.files.forEach(file => {
            this.uploadFile(file);
        });
      }

    doUpload() {
        this.files = [];
        const fileUpload = this.fileUpload.nativeElement;
        fileUpload.onchange = () => {
            /*
            for (let index = 0; index < fileUpload.files.length; index++) {
                const file = fileUpload.files[index];
                this.files.push({ data: file, inProgress: false, progress: 0});
            }
            */
            for (const file of fileUpload.files) {
              this.files.push({ data: file, inProgress: false, progress: 0});
            }
            this.uploadFiles();
        };
        fileUpload.click();
    }

    loadImgs() {
        this.imgs = [];
        this.dirs = [];
        this.loadingImgs = true;
        this.ajax.get('GetDocs', {
            table: 'orders', value: this.ordernr, subdir: '/foto' + this.currSub
        }).then((data: any) => {
            console.log('loadImgs:', data);
            this.dirs = data.Dir;
            this.imgs = data.Imgs;
            this.docs = data.Docs;
            this.loadingImgs = false;
        });
    }

    async openFile(url) {
        await Browser.open({ url: url });
    }

    doChDir(nwdir) {
        if (nwdir === '..') {
            this.currSub = this.currSub.substr(0, this.currSub.lastIndexOf('/'));
        } else {
            this.currSub = this.currSub + '/' + nwdir;
        }
        this.loadImgs();
    }

    doMkdir() {
        const nwDir = prompt('Naam nieuwe map');
        this.ajax.get('mkDir', {
            table: 'orders', value: this.ordernr, subdir: '/foto' + this.currSub,
            nwdir: nwDir
        }).then((data: any) => {
            if (data.nwdir) {
                // this.dir
                this.loadImgs();
            }
        });
    }

    async addUren() {
        const urenDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'uren',
                id: '*NEW*',
                defaults: {
                    OrderNr: this.ordernr
                },
            }
        });
        urenDlg.onDidDismiss()
        .then(data => {
            // klaar met addUren -> refresh
            this.showProjKaart(this.ordernr);
        });
        return await urenDlg.present();
    }

    async editUren(editID) {
        const urenDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'uren',
                id: editID,
                defaults: {},
            }
        });
        urenDlg.onDidDismiss()
        .then(data => {
            // klaar met addUren -> refresh
            this.showProjKaart(this.ordernr);
        });
        return await urenDlg.present();
    }

    async addAantek() {
        const myDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'aantek',
                id: '*NEW*',
                defaults: {
                    LiproOrderNr: this.ordernr,
                    KoppelTabel: 'orders',
                    Door: this.global.usrvalue,
                    Voor: this.global.usrvalue,
                },
            }
        });
        myDlg.onDidDismiss()
        .then(data => {
            // klaar met addUren -> refresh
            this.showProjKaart(this.ordernr);
        });
        return await myDlg.present();
    }

    async editAantek(editID) {
        const myDlg = await this.modalController.create({
            component: RecordFormPage,
            componentProps: {
                table: 'aantek',
                id: editID,
                defaults: {},
            }
        });
        myDlg.onDidDismiss()
        .then(data => {
            // klaar met addUren -> refresh
            this.showProjKaart(this.ordernr);
        });
        return await myDlg.present();
    }

    drawStart(event: Event) {
        // will be notified of szimek/signature_pad's onBegin event
        console.log('begin drawing', event);
    }

    drawMoved(event: Event) {
        // works in device not in browser
        console.log('draw moved');
    }

    drawEnd() {
        console.log('draw end');
        this.handtekGezet = true;
    }

    drawClear() {
        if (this.signaturePad) {
            this.signaturePad.clear();
        }
        this.handtekGezet = false;
    }

    drawClearOpdr() {
        this.signOpdrPad.clear();
        this.handtekGezet = false;
    }

    goAfboeken() {
        if (this.global.optAfbV2) {
            this.router.navigateByUrl('afboeking2');
        } else {
            this.router.navigateByUrl('afboeking');
        }
    }

    async dlgRtoB(Qty, ArtNr, Eenh) {
        const alert = await this.alertController.create({
            header: 'Afboeken',
            message: 'Afboeken van ' + ArtNr + ' [' + Eenh + ']',
            inputs: [
                {
                    name: 'q',
                    type: 'number',
                    placeholder: 'Aantal',
                    value: Qty
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('telling cancelled');
                    }
                }, {
                    text: 'Ok',
                    handler: (alertData) => {
                        this.ajax.get('artVerbruik', {
                            req: ArtNr,
                            proj: this.ordernr,
                            qty: alertData.q,
                        })
                        .then((data: any) => {
                                if (!data.login) {
                                    this.dataError(data);
                                } else {
                                    console.log('got2 = ', data);
                                    this.showProjKaart(this.ordernr);
                                }
                        });
                    }
                }
            ]
        });
        await alert.present();
    }

    onResize() {
        // gridCols = fotothumbs
        // gridTredes = treden-meetstaat
          if (window.innerWidth <= 400) {
            this.gridCols = 2;
          } else {
            this.gridCols = Math.floor(window.innerWidth / 200);
          }
          if (window.innerWidth <= 400) {
            this.gridTredes = 1;
          } else {
            this.gridTredes = Math.floor(window.innerWidth / 400);
          }

          this.gridSelectCols = (window.innerWidth <= 700) ? 1 : 3;
          this.gridHeight = (window.innerWidth <= 700) ? (window.innerHeight - 60) / 3 : (window.innerHeight - 60);
    }

    chInstructie() {
        this.ajax.get('orderUpdateInstructie', {
            val: this.ordInstr.value,
            req: this.ordernr
        })
            .then((data: any) => {
                if (!data.login) {
                    this.dataError(data);
                } else {
                    console.log('got3 = ', data);
                    this.showProjKaart(this.ordernr);
                    this.editInstr = false;
                }
            });
    }

    async dataError(data) {
        console.log(data);
        this.snackBar.open('Nieuwe login noodzakelijk', 'OK', {
            duration: 1000
        });
        this.router.navigateByUrl('login');
      }

      openWerkbon(bonnr) {
        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', this.global.baseurl + 'api/img.php');
        form.setAttribute('target', '_blank');
        // https://cloud.lisaas.com/demokleur/img.php?t=werkbon&f=Bon&i=ID&v=385&c=application/pdf
        const params = {
            compname: this.global.compname,
            username: this.global.username,
            password: this.global.password,
            session: this.global.session,
            pcnr: this.global.uuid,
            t: 'werkbon',
            f: 'Bon',
            i: 'ID',
            v: bonnr,
            c: 'application/pdf'
        }
        for (const i in params) {
          if (params.hasOwnProperty(i)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = i;
            input.value = params[i];
            form.appendChild(input);
          }
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }

      mapsUrl(adr: string) {
        return 'https://www.google.com/maps/dir/?api=1&destination='
        + adr.replace(/(?:\r\n|\r|\n)/g, ',');
    }

    // -------------------------------- tbv OPDRACHT tab:

    ordrNwLine() {
        this.ordrQty=1;
        this.ordrArtnr='';
        this.ordrOms='';
        this.ordrArtShow={};
        this.ordrArtShowImg='';
        this.ordrLineID='*NEW*';
        this.ordrLineEdit=true;
    }

    ordrEditLine(lin) {
        this.ordrQty=lin.Qty;
        this.ordrArtnr=lin.amArtNr;
        this.ordrLineID=lin.ID;
        this.ordrArtShow={};
        this.ordrArtShowImg='';
        this.showArtKaart(lin.amArtNr);
        this.ordrLineEdit=true;
    }

    ordrSaveLine() {
        if (this.ordrArtnr=='') {
            this.ordrArtnr='x';
        } else {
            this.ordrArtnr=this.ordrArtShow['artnr'];
        }
        this.ordrOms.replace('"', '``');
        this.ordrOms.replace('\'', '`');
        if (this.ordrLineID=='*NEW*' && this.ordrQty!==0) {
            console.log('INSERT into artmut set '
            + 'amArtNr="' + this.ordrArtnr + '", '
            + 'amQty="' + this.ordrQty + '", '
            + 'amOpm="' + this.ordrOms + '", '
            + 'amOrderNr="' + this.ordernr + '", '
            + 'amType="-", '
            + 'amSoort="W"');
            this.ajax.get('insert', {
                sql: 'INSERT into artmut set '
                    + 'amArtNr="' + this.ordrArtnr + '", '
                    + 'amQty="' + this.ordrQty + '", '
                    + 'amOpm="' + this.ordrOms + '", '
                    + 'amOrderNr="' + this.ordernr + '", '
                    + 'amType="-", '
                    + 'amSoort="W"'
            }).then((data: any) => {
                this.ordrLineEdit=false;
                this.ordrReloadMut();
            })
        } else if (this.ordrQty!==0) {
            // edit existing line
            this.ajax.get('updateRecord', {
                table: 'artmut',
                fields: {
                    amArtNr: this.ordrArtnr,
                    amQty: this.ordrQty
                },
                field: 'amID',
                value: this.ordrLineID
            }).then((data: any) => {
                this.ordrLineEdit=false;
                this.ordrReloadMut();
            })
        } else {
            // delete line
            this.ajax.get('deleteRecord', {
                table: 'artmut',
                field: 'amID',
                value: this.ordrLineID
            }).then((data: any) => {
                this.ordrLineEdit=false;
                this.ordrReloadMut();
            })
        }
    }

    ordrReloadMut() {
        this.ajax.get('orderDetails', {req: this.ordernr})
        .then((data: any) => {
            if (!data.login) {
                this.dataError(data);
            } else {
                this.artikelen = (data.artikelen) ? data.artikelen : [];
                this.calcTotal();
            }
        });
    }

    artChanged(event) {
        console.log('artChanged:', event);
        this.ajax.get('comboChoices', {
            table: 'artikelen',
            txt: event
        })
            .then((data: any) => {
                console.log('artChoices:', data);
                this.ordrArtChoices = (data.choices) ? data.choices : [];
                if (this.ordrArtChoices.length==1) {
                    this.showArtKaart(this.ordrArtChoices[0].ID.trim());
                } else {
                    if (data.choices) {
                        data.choices.forEach(element => {
                            if (element.ID.toLowerCase().trim() === this.ordrArtnr.toLowerCase().trim()) {
                                this.showArtKaart(this.ordrArtnr.trim());
                            }
                        });
                    }
                }
            });
    }

    calcTotal() {
        this.subtotalExcl = 0;
        this.subtotalIncl = 0;
        this.artikelen.forEach( a=> this.subtotalExcl += parseFloat(a.Verkoopprijs.replace(/,/g,'')) * a.Qty);
        this.artikelen.forEach( a=> this.subtotalIncl += parseFloat(a.VerkoopprijsIncl.replace(/,/g, '')) * a.Qty);
        this.subtotalExclDispl = this.subtotalExcl.toFixed(2);
        this.subtotalInclDispl = this.subtotalIncl.toFixed(2);
        let kortingExcl = this.projData.KlantKorting / 100 * this.subtotalExcl;
        let kortingIncl = this.projData.KlantKorting / 100 * this.subtotalIncl;
        this.kortingExclDispl = kortingExcl.toFixed(2);
        this.kortingInclDispl = kortingIncl.toFixed(2);
        this.totalExclDispl = (this.subtotalExcl - kortingExcl).toFixed(2);
        this.totalInclDispl = (this.subtotalIncl - kortingIncl).toFixed(2);
    }

    showArtKaart(artnr) {
        console.log('showArtKaart: ' + artnr);
        this.ajax.get('artData', { req: artnr })
        .then((data: any) => {
            if (!data.login) {
                this.dataError(data);
            } else {
                console.log('got1 = ', data);
                this.ordrArtShow = data;
                this.ordrArtShowImg = this.global.baseurl
                    + 'api/img.php?t=artikelen&f=Foto&i=ArtNr&v=' + artnr
                    + '&compname=' + this.global.compname
                    + '&username=' + this.global.username
                    + '&password=' + this.global.password
                    + '&session=' + this.global.session
                    + '&app=BAR3'
                    + '&pcnr=' + this.global.uuid;
                this.imgs[0] = {
                    filename: artnr,
                    path: '',
                    txt: artnr,
                    url: this.ordrArtShowImg
                };
                this.global.currArtNr = artnr;
                localStorage.setItem('lastArtNr', artnr);
            }
        });
    }

}
